module.exports = __webpack_public_path__ + "img/mobileShield2.8ea2b46f.png";